import React, { useState } from "react";

const MessageBubble = ({
  message,
  isOwnMessage,
  showSender,
  conversationType = "direct",
}) => {
  const [showReadTime, setShowReadTime] = useState(false);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatReadTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const isRead =
    message.read_by_recipient === true || message.read_by_recipient === 1;
  const isGroup = conversationType === "group";
  const readCount = message.read_count ?? 0;
  const totalRecipients = message.total_recipients ?? 0;

  const renderReadReceipt = () => {
    if (!isOwnMessage) return null;

    if (isGroup) {
      if (readCount > 0) {
        return (
          <div className="message-read-receipt message-read-receipt-group">
            <span className="read-receipt-text">
              Read by {readCount} of {totalRecipients}
            </span>
          </div>
        );
      }
      return null;
    }

    // 1:1 - iOS style Delivered / Read
    return (
      <div
        className="message-read-receipt"
        onMouseEnter={() => setShowReadTime(true)}
        onMouseLeave={() => setShowReadTime(false)}
      >
        <span
          className={`read-receipt-text read-receipt-${isRead ? "read" : "delivered"}`}
          title={
            isRead && message.read_at
              ? `Read at ${formatReadTime(message.read_at)}`
              : isRead
                ? "Read"
                : "Delivered"
          }
        >
          {isRead ? "Read" : "Delivered"}
        </span>
        {showReadTime && message.read_at ? (
          <span className="read-time-tooltip">
            Read {formatReadTime(message.read_at)}
          </span>
        ) : null}
      </div>
    );
  };

  return (
    <div
      className={`message-bubble-container ${isOwnMessage ? "own" : "other"}`}
    >
      {!isOwnMessage && showSender && (
        <div className="message-sender-name">{message.sender_name}</div>
      )}

      <div className="message-bubble">
        <div className="message-text">
          {message.message_text}
          {message.is_edited === true || message.is_edited === 1 ? (
            <span className="message-edited"> (edited)</span>
          ) : null}
        </div>

        <div className="message-meta">
          <div className="message-time">{formatTime(message.created_at)}</div>
          {renderReadReceipt()}
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
